import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import {
  ViedocButtonElement,
  ViedocDialogElement,
  ViedocTextareaElement,
} from "../../../../secure/elements/ViedocReactElements";

const StatusDialogueBox = ({ setLockUnlockStatusMsg, handleSubmit }) => {
  const { isEtmfLocked } = useSelector((store) => store.template);
  const [value, setValue] = useState("");
  const { t } = useTranslation();

  const handleTextAreaOnchange = (e) => {
    setValue(e.target.value);
    setLockUnlockStatusMsg(e.target.value);
  };

  return (
    <ViedocDialogElement
      id="StatusDialogueBox"
      size="medium"
      overlay="#000000"
      preventCloseByClick
    >
      <header slot="header">
        {isEtmfLocked
          ? t("ADMIN.TEXT_CONFIRMETMFUNLOCK")
          : t("ADMIN.TEXT_CONFIRMETMFLOCK")}
      </header>
      <main>
        <div className="info-container">
          <div className="info-message">
            <viedoc-icon name="info" />
            <p className="lh1_3">
              {isEtmfLocked
                ? t("ADMIN.TEXT_UNLOCK")
                : t("ADMIN.TEXT_ETMFLOCKFOOTER")}
            </p>
          </div>
        </div>
        <form className="status-dialog pt-20 pb-20">
          <ViedocTextareaElement
            label={t("ADMIN.TEXT_GIVEREASON")}
            placeholder={t("TMF.TEXT_TYPE")}
            value={value}
            maxLength={47}
            onChange={handleTextAreaOnchange}
            multiLine
            class="statusBox"
          ></ViedocTextareaElement>
        </form>
      </main>
      <footer slot="footer" className="status-footer">
        <div className="d-flex">
          <ViedocButtonElement
            variant={value.trim().length === 0 ? "neutral" : "success"}
            size="small"
            disabled={value.trim().length === 0}
            onClick={() => {
              handleSubmit();
              setValue("");
            }}
            title={t("ADMIN.BUTTON_CONFIRM")}
          >
            {t("ADMIN.BUTTON_CONFIRM")}
          </ViedocButtonElement>
        </div>
      </footer>
    </ViedocDialogElement>
  );
};

export default StatusDialogueBox;
